import React from 'react';
import { useLocation } from 'react-router-dom';
import { PermissionProvider } from '../contexts/PermissionContext';
import PermissionGuard from '../components/Auth/PermissionGuard';
import DashboardLayout from '../components/Dashboard/DashboardLayout';
import Dashboard from './Dashboard';
import AdminProducts from './AdminProducts';
import AdminCategories from './AdminCategories';
import AdminEmployees from './AdminEmployees';
import AdminCustomers from './AdminCustomers';
import AdminReports from './AdminReports';
import AdminSettings from './AdminSettings';
import AdminOrders from './AdminOrders';
import AdminOrderDetail from './AdminOrderDetail';
import AdminSuppliers from './AdminSuppliers';
import AdminPurchaseInvoices from './AdminPurchaseInvoices';
import AdminWarehouse from './AdminWarehouse';
import AdminOutlets from './AdminOutlets';
import EmployeeReferrals from './EmployeeReferrals';

const DashboardRouter = () => {
  const location = useLocation();

  const renderContent = () => {
    if (location.pathname === '/dashboard' || location.pathname === '/dashboard/') {
      return <Dashboard />;
    } else if (location.pathname === '/dashboard/products') {
      return (
        <PermissionGuard module="products">
          <AdminProducts />
        </PermissionGuard>
      );
    } else if (location.pathname === '/dashboard/categories') {
      return (
        <PermissionGuard module="categories">
          <AdminCategories />
        </PermissionGuard>
      );
    } else if (location.pathname === '/dashboard/orders') {
      return (
        <PermissionGuard module="orders">
          <AdminOrders />
        </PermissionGuard>
      );
    } else if (location.pathname.startsWith('/dashboard/orders/')) {
      return (
        <PermissionGuard module="orders">
          <AdminOrderDetail />
        </PermissionGuard>
      );
    } else if (location.pathname === '/dashboard/employees') {
      return (
        <PermissionGuard permission="employees.manage">
          <AdminEmployees />
        </PermissionGuard>
      );
    } else if (location.pathname === '/dashboard/customers') {
      return (
        <PermissionGuard module="customers">
          <AdminCustomers />
        </PermissionGuard>
      );
    } else if (location.pathname === '/dashboard/reports') {
      return (
        <PermissionGuard module="reports">
          <AdminReports />
        </PermissionGuard>
      );
    } else if (location.pathname === '/dashboard/my-referrals') {
      return <EmployeeReferrals />;
    } else if (location.pathname === '/dashboard/settings') {
      return (
        <PermissionGuard permission="settings.manage">
          <AdminSettings />
        </PermissionGuard>
      );
    } else if (location.pathname === '/dashboard/outlets') {
      return (
        <PermissionGuard permission="settings.manage">
          <AdminOutlets />
        </PermissionGuard>
      );
    } else if (location.pathname === '/dashboard/suppliers') {
      return (
        <PermissionGuard module="purchases">
          <AdminSuppliers />
        </PermissionGuard>
      );
    } else if (location.pathname === '/dashboard/purchase-invoices') {
      return (
        <PermissionGuard module="purchases">
          <AdminPurchaseInvoices />
        </PermissionGuard>
      );
    } else if (location.pathname === '/dashboard/analytics') {
      return (
        <PermissionGuard anyPermission={['reports.view', 'reports.export']}>
          <AdminReports />
        </PermissionGuard>
      );
    } else if (location.pathname === '/dashboard/sales') {
      return (
        <PermissionGuard module="orders">
          <AdminReports />
        </PermissionGuard>
      );
    } else if (location.pathname === '/dashboard/warehouse') {
      return (
        <PermissionGuard module="warehouse">
          <AdminWarehouse />
        </PermissionGuard>
      );
    } else {
      return <Dashboard />;
    }
  };

  return (
    <PermissionProvider>
      <DashboardLayout>
        {renderContent()}
      </DashboardLayout>
    </PermissionProvider>
  );
};

export default DashboardRouter;

